import gql from "graphql-tag";

export const CHATS_FOR_USER = gql`
  query chatsForUser($userId: String) {
    chatsForUser(userId: $userId) {
      edges {
        node {
          id
          title
          image
          lastMessageTimestamp
          type
          userchatSet {
            id
            lastViewedTimestamp
            user {
              id
              isStaff
            }
          }
          lastMessage {
            id
            text
            createdAt
            messageattachmentSet {
              id
              type
            }
            user {
              id
              firstName
              isStaff
            }
          }
        }
      }
    }
  }
`;

export const CHAT_GROUP_METRICS_QUERY = gql`
  query chatGroupMetrics {
    chatGroupMetrics {
      label
      total
    }
  }
`;

export const ALL_CHATS = gql`
  query allChats(
    $title: String
    $lastMessageTimestamp_Lte: DateTime
    $lastMessageTimestamp_Gte: DateTime
    $creator_Username: String
    $type_In: [String]
    $users_Username_Icontains: String
    $isSystemCreated: Boolean
    $after: String
    $first: Int
    $orderBy: String
  ) {
    allChats(
      title_Icontains: $title
      lastMessageTimestamp_Lte: $lastMessageTimestamp_Lte
      lastMessageTimestamp_Gte: $lastMessageTimestamp_Gte
      creator_Username: $creator_Username
      type_In: $type_In
      users_Username_Icontains: $users_Username_Icontains
      isSystemCreated: $isSystemCreated
      after: $after
      first: $first
      orderBy: $orderBy
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          title
          lastMessageTimestamp
          type
          engaged
          totalMessages
          messagesThreeDays
          messagesSevenDays
          users {
            id
            username
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const CHAT_STATS_QUERY = gql`
  query chatStats(
    $title: String
    $lastMessageTimestampGte: DateTime
    $typeIn: [String]
    $usernameContains: String
    $isSystemCreated: Boolean
  ) {
    chatStats(
      lastMessageTimestampGte: $lastMessageTimestampGte
      title: $title
      typeIn: $typeIn
      usernameContains: $usernameContains
      isSystemCreated: $isSystemCreated
    ) {
      label
      total
    }
  }
`;

export const CHATS_INACTIVE_STAFF = gql`
  query chatsInactiveStaff($chatType: String!) {
    chatsInactiveStaff(chatType: $chatType) {
      id
      title
      type
      users {
        id
        firstName
        lastName
        isStaff
        isActive
      }
    }
  }
`;
